/**
 * A short "hammer strike" on the phone, for the moments that land something:
 * a lookup fired, an invoice generated, a payment recorded.
 *
 * Android Chrome supports the Vibration API; iOS Safari does not, so iPhones
 * simply get nothing (the ember flash on the button still shows). Never
 * throws: a blocked or missing API is not an error worth reporting.
 */
export type Strike = 'tap' | 'land';

const PATTERNS: Record<Strike, number | number[]> = {
    tap: 12,
    land: [10, 40, 18],
};

export function strike(kind: Strike = 'tap'): void {
    try {
        if (typeof navigator !== 'undefined' && typeof navigator.vibrate === 'function') {
            navigator.vibrate(PATTERNS[kind]);
        }
    } catch {
        // Vibration is a nicety; a browser that refuses it changes nothing.
    }
}
